import React, { useEffect, useMemo, useState } from 'react';
import { useQuery, gql } from '@apollo/client';
import DetalleAcusadoModal from './DetalleAcusadoModal';
import { formatDate } from '../utils/formatDate';

const GET_ACUSADOS = gql`
  query GetAcusados {
    acusados {
      id
      nombre_completo
      cedula
      grado
      unidad
      estado_actual
      resumen_caso
      direccion
      estado_civil
      edad
      fecha_nacimiento
      foto
      created_at
      updated_at
    }
  }
`;

const mapAcusado = (row) => {
  const fecha = row.updated_at || row.created_at || '';
  return {
    acusado_id: row.id,
    nombre: row.nombre_completo,
    cedula: row.cedula,
    grado: row.grado,
    unidad: row.unidad,
    estado_procesal: row.estado_actual,
    resumen_caso: row.resumen_caso,
    direccion: row.direccion,
    estado_civil: row.estado_civil,
    edad: row.edad,
    fecha_nacimiento: row.fecha_nacimiento,
    foto: row.foto,
    fecha_actualizacion: formatDate(fecha),
  };
};



export default function ListaAcusados({ acusados, setAcusados, onAbrirDetalle, onIrRegistrar, onVolver }) {
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState('');
  const [acusadoSeleccionado, setAcusadoSeleccionado] = useState(null);
  const { data, loading, error: queryError } = useQuery(GET_ACUSADOS, {
    fetchPolicy: 'network-only',
    errorPolicy: 'all',
  });

  const dataAcusados = useMemo(() => {
    if (!data?.acusados) return null;
    return data.acusados.map(mapAcusado);
  }, [data]);
  

  useEffect(() => {
    if (dataAcusados) {
      if (typeof setAcusados === 'function') {
        setAcusados(dataAcusados);
      }
      setCargando(false);
      return;
    }
    if (loading) return;
    if (queryError) {
      setError('Error al cargar los acusados');
      setCargando(false);
      return;
    }
    setCargando(false);
  }, [dataAcusados, loading, queryError, setAcusados]);


  const handleAbrirDetalle = (acusado) => {
    if (onAbrirDetalle) return onAbrirDetalle(acusado);
    setAcusadoSeleccionado(acusado);
  };

  const handleCerrarDetalle = () => {
    setAcusadoSeleccionado(null);
  };

  const handleEstadoActualizado = (actualizado) => {
    setAcusados(acusados.map(a => a.acusado_id === actualizado.acusado_id ? { ...a, ...actualizado } : a));
  };

  if (cargando) return <div>Cargando...</div>;
  if (error) return <div style={{ color: 'red' }}>{error}</div>;

  const Avatar = ({ a, size = 28 }) => {
    const styleImg = { width: size, height: size, objectFit: 'cover', borderRadius: '50%', border: '1px solid #ddd' };
    if (a.foto) return <img src={a.foto} alt={a.nombre} style={styleImg} />;
    const iniciales = (a.nombre || '').trim().split(/\s+/).slice(0,2).map(x => x[0]?.toUpperCase() || '').join('');
    return (
      <div style={{...styleImg, display:'inline-flex', alignItems:'center', justifyContent:'center', background:'#f1f3f5', fontSize:12 }}>
        {iniciales || 'A'}
      </div>
    );
  };

  return (
    <div className="container" style={{ maxWidth: 900, marginTop: 40 }}>
      {onVolver && (
        <button className="btn btn-outline-primary btn-volver mb-3" onClick={onVolver}>
          <i className="bi bi-arrow-left"></i>
          <span>Volver</span>
        </button>
      )}
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2 className="mb-0">Lista de Acusados</h2>
        <button className="btn btn-success" onClick={() => onIrRegistrar && onIrRegistrar()}>Registrar nuevo acusado</button>
      </div>
      <div className="table-responsive">
        <table className="table table-bordered align-middle">
          <thead className="table-light">
            <tr>
              <th style={{ width: 56 }}>Foto</th>
              <th>Nombre</th>
              <th>Grado</th>
              <th>Unidad</th>
              <th>Estado Procesal</th>
              <th>Fecha Actualización</th>
            </tr>
          </thead>
          <tbody>
            {acusados.map(a => (
              <tr key={a.acusado_id} style={{ cursor: 'pointer' }} onClick={() => handleAbrirDetalle(a)}>
                <td className="text-center"><Avatar a={a} /></td>
                <td>{a.nombre}</td>
                <td>{a.grado}</td>
                <td>{a.unidad}</td>
                <td>{
                  {
                    'en_investigacion': 'En investigación',
                    'en_juicio': 'En juicio',
                    'sentenciado': 'Sentenciado',
                    'absuelto': 'Absuelto',
                  }[a.estado_procesal]
                }</td>
                <td>{a.fecha_actualizacion}</td>
              </tr>
            ))}
            {acusados.length === 0 && (
              <tr>
                <td colSpan="6" className="text-center text-muted py-4">Sin acusados registrados</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {/* Si no se pasa onAbrirDetalle, se usa el modal como fallback */}
      {acusadoSeleccionado && !onAbrirDetalle && (
        <DetalleAcusadoModal
          acusado={acusadoSeleccionado}
          onClose={handleCerrarDetalle}
          onEstadoActualizado={handleEstadoActualizado}
        />
      )}
    </div>
  );
}
